import axios from "axios";
import { Box, Link, TextField } from "@mui/material";
import localize from "../../../common/localize";
import Combobox from "../../../components/common/Combobox";
import { useEffect, useState } from "react";
import useGlobalContext from "../../../hooks/useGlobalContext";
import { getInputLabelProps, getInputProps } from "../../../common/appStyles";
import { TabContext, TabPanel } from "@mui/lab";
import ScrollablePageTab from "../../dynamicForm/components/ScrollablePageTab";
import TableComponent from "../../../components/common/TableComponent";
import { BackForeColor } from "../../../components/common/BackForeColor";
import ValueOrNoDataLabel from "../../../components/common/ValueOrNoDataLabel";
import TotalValueItem from "../../event/components/TotalValueItem";
import PaymentIcon from "../../event/components/PaymentIcon";
import BillIcon from "../../event/components/BillIcon";
import NoDataLabel from "../../../components/common/NoDataLabel";
import { generateNoDataValues } from "../../../common/utils";

export default function AddOrEditBranch({ model, setModel }) {
  const { locations, setCity, cities, setCityFilterCode, EVENTS_API, config } =
    useGlobalContext();
  const [states, setStates] = useState(null);
  const [citiesData, setCities] = useState(null);
  const [eventsData, setEventsData] = useState([]);
  const [selectedTabPage, setSelectedtabPage] = useState("0");

  const getTabPages = () => {
    const result = [
      {
        Id: "0",
        Name: localize.general_information,
      },
    ];

    if (model?.Id > 0) {
      result.push({
        Id: "1",
        Name: localize.events,
      });
    }

    return result;
  };

  const changeTab = (value) => {
    value >= 0 && setSelectedtabPage(value.toString());
  };

  const getEvents = async () => {
    const result = await axios.get(`${EVENTS_API}/branch/${model.Id}`, config);

    if (
      result?.data?.Ok &&
      result?.data?.Data &&
      result?.data?.Data?.length > 0
    ) {
      setEventsData([...result.data.Data]);
    }
  };

  const handleChange = (e) => {
    setModel({
      ...model,
      [e.target.name]: e.target.value,
    });
  };

  const handleStateChange = (currentState) => {
    if (!currentState) {
      setModel({
        ...model,
        StateId: 0,
        State: null,
        CityId: 0,
        City: null,
      });
      return;
    }

    setModel({
      ...model,
      StateId: currentState.Id,
      State: currentState,
      CityId: 0,
      City: null,
    });
  };

  const handleCityChange = (currentCity) => {
    if (!currentCity) {
      setModel({
        ...model,
        CityId: 0,
        City: null,
      });
      return;
    }

    setModel({
      ...model,
      CityId: currentCity.Id,
      City: currentCity,
    });

    setCityFilterCode(currentCity.Code);
  };

  const validateStateChange = () => {
    if (model?.State) {
      model.StateId = model?.State.Id;
    }

    if (model?.StateId > 0) {
      const selectedState = states?.find(
        (element) => element.Id === model?.StateId
      );
      if (selectedState) {
        setCity(selectedState.Code);
      }
    }
  };

  useEffect(() => {
    if (cities && cities.length > 0 && model?.City) {
      setCityFilterCode(model.City.Code);
    }
  }, [cities]);

  useEffect(() => {
    validateStateChange();
  }, [model?.StateId, states]);

  useEffect(() => {
    if (locations.Ok && locations.Data.length > 0) {
      setStates(locations.Data);
    }
  }, [locations]);

  useEffect(() => {
    if (cities.Ok && cities.Data.length > 0) {
      setCities(cities.Data);
    }
  }, [cities]);

  useEffect(() => {
    if (model?.Id > 0) {
      getEvents();
    }
  }, [model?.Id]);

  return (
    <TabContext
      value={selectedTabPage}
      className="lateral_padding"
      style={{ width: 800 }}
    >
      {model?.Id > 0 && (
        <Box sx={{ width: 800, borderBottom: 1, borderColor: "divider" }}>
          <ScrollablePageTab
            selectedPage={parseInt(selectedTabPage)}
            setSelectedPage={changeTab}
            noMarginTop
            dynamicFormPages={getTabPages()}
          />
        </Box>
      )}

      <TabPanel value="0">
        <Box className="flex flex-col gap-3" sx={{ width: 750 }}>
          <TextField
            required
            InputLabelProps={getInputLabelProps()}
            inputProps={getInputProps()}
            size="small"
            fullWidth
            name="Name"
            id="Name"
            value={model.Name}
            label={localize.name}
            variant="outlined"
            onChange={handleChange}
          />

          <div className="flex justify-between gap-2">
            <Combobox
              isRequired
              id="State"
              handleValueChange={handleStateChange}
              fieldValue={model?.State}
              fieldOptions={states ?? []}
              fieldLabel={localize.department}
            />

            {/* Cities */}
            <Combobox
              isRequired
              id="City"
              handleValueChange={handleCityChange}
              fieldValue={model?.City}
              fieldOptions={model?.State ? citiesData ?? [] : []}
              fieldLabel={localize.city}
            />
          </div>

          <div className="flex justify-between gap-2">
            <TextField
              required
              InputLabelProps={getInputLabelProps()}
              inputProps={getInputProps()}
              size="small"
              fullWidth
              name="Address"
              id="Address"
              value={model.Address}
              label={localize.address}
              variant="outlined"
              onChange={handleChange}
            />

            <TextField
              InputLabelProps={getInputLabelProps()}
              inputProps={getInputProps()}
              size="small"
              fullWidth
              name="AddressComplement"
              id="AddressComplement"
              value={model.AddressComplement}
              label={localize.address_complement}
              variant="outlined"
              onChange={handleChange}
            />
          </div>

          <div className="flex justify-between gap-2">
            <TextField
              required
              InputLabelProps={getInputLabelProps()}
              inputProps={getInputProps()}
              size="small"
              fullWidth
              name="PhoneNumber"
              id="PhoneNumber"
              value={model.PhoneNumber}
              label={localize.phone_number}
              variant="outlined"
              onChange={handleChange}
            />

            <TextField
              InputLabelProps={getInputLabelProps()}
              inputProps={getInputProps()}
              size="small"
              fullWidth
              name="Email"
              id="Email"
              value={model.Email}
              label={localize.email}
              variant="outlined"
              onChange={handleChange}
            />
          </div>

          <TextField
            InputLabelProps={getInputLabelProps()}
            inputProps={getInputProps()}
            size="small"
            fullWidth
            value={model.ContactName}
            name="ContactName"
            id="ContactName"
            label={localize.contact_name}
            variant="outlined"
            onChange={handleChange}
          />
        </Box>
      </TabPanel>

      {model?.Id > 0 && (
        <TabPanel value="1">
          <div style={{ width: 800, height: 250 }}>
            <TableComponent
              noPadding
              columnTitles={[
                localize.code,
                localize.event_type,
                localize.execution_status,
                localize.proceeding,
                localize.total_value,
                localize.payed,
                localize.billed,
                localize.assigned_to,
                localize.creation_date,
              ]}
              results={
                eventsData?.length > 0
                  ? eventsData?.map((item) => ({
                      key: item.Id,
                      data: [
                        <Link
                          color="primary"
                          underline="always"
                          href="#"
                          onClick={() => {
                            window.open(`/events/detail/${item.Id}`, "_blank");
                          }}
                        >{`${item.Code}`}</Link>,
                        <BackForeColor
                          backColor={item.EventType.BackgroundColor}
                          foreColor={item.EventType.ForegroundColor}
                          text={item.EventType.Name}
                        />,
                        <BackForeColor
                          backColor={
                            item.OperationalStatus === 0
                              ? "white"
                              : item.CurrentStatus?.BackgroundColor
                          }
                          foreColor={
                            item.OperationalStatus === 0
                              ? "red"
                              : item.CurrentStatus?.ForegroundColor
                          }
                          text={
                            item.OperationalStatus === 0
                              ? localize.cancelled
                              : item.CurrentStatus?.Name
                          }
                          styleName={
                            item.OperationalStatus === 0
                              ? "cancelled_operational_status"
                              : ""
                          }
                        />,
                        <ValueOrNoDataLabel data={item.ProceedingInfo?.Name} />,
                        <TotalValueItem item={item} />,
                        <PaymentIcon item={item} />,
                        <BillIcon item={item} />,
                        item.PersonalAssigned ? (
                          <p>{`${item.PersonalAssigned.SurName} ${item.PersonalAssigned.LastName}`}</p>
                        ) : (
                          <NoDataLabel />
                        ),
                        new Date(item.CreationDate).toLocaleString(undefined, {
                          year: "numeric",
                          month: "2-digit",
                          day: "2-digit",
                          hour: "2-digit",
                          minute: "2-digit",
                          second: "2-digit",
                        }),
                      ],
                    }))
                  : [generateNoDataValues(9)]
              }
            />
          </div>
        </TabPanel>
      )}
    </TabContext>
  );
}
